import React from 'react';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Input from '@amzn/meridian/input';

const QuantityButtonCellRenderer = (props: {
  value: number;
  setValue: (input: number) => void;
  column: { colId: string };
}) => {
  const { value, setValue, column } = props;

  const onIncrement = () => {
    setValue(+value + 1);
  };

  const onDecrement = () => {
    const minFacingUnits = column.colId.valueOf() === 'facingUnits' ? 1 : 0;
    setValue(Math.max(minFacingUnits, +value - 1));
  };

  return (
    <Row spacing="none" spacingInset="none" maxWidth="50">
      <Button onClick={onDecrement} type="secondary">
        -
      </Button>
      <Input width="60px" type="number" value={value} onChange={setValue} role="spinbutton" />
      <Button onClick={onIncrement} type="secondary">
        +
      </Button>
    </Row>
  );
};

export default QuantityButtonCellRenderer;
